var _rect, _rect2, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLowImg = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 25,
    viewBox: "0 0 92 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.288863,
    y: 0.288863,
    width: 91.4223,
    height: 24.4223,
    rx: 5.48839,
    fill: "url(#paint0_radial_155_81)",
    fillOpacity: 0.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.288863,
    y: 0.288863,
    width: 91.4223,
    height: 24.4223,
    rx: 5.48839,
    stroke: "#17B9FF",
    strokeOpacity: 0.1,
    strokeWidth: 0.577726
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.288863,
    y: 0.288863,
    width: 91.4223,
    height: 24.4223,
    rx: 5.48839,
    stroke: "url(#paint1_linear_155_81)",
    strokeWidth: 0.577726,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4602 16.3809V6.17486H34.6502V15.2889H39.6902V16.3809H33.4602ZM43.7524 16.5069C43.0431 16.5069 42.4224 16.3529 41.8904 16.0449C41.3584 15.7275 40.9431 15.2842 40.6444 14.7149C40.3457 14.1455 40.1964 13.4829 40.1964 12.7269C40.1964 11.9709 40.3411 11.3082 40.6304 10.7389C40.9197 10.1695 41.3304 9.72619 41.8624 9.40886C42.4037 9.08219 43.0337 8.91886 43.7524 8.91886C44.4617 8.91886 45.0777 9.07753 45.6004 9.39486C46.1324 9.70286 46.5431 10.1415 46.8324 10.7109C47.1311 11.2709 47.2804 11.9382 47.2804 12.7129C47.2804 13.4595 47.1357 14.1175 46.8464 14.6869C46.5571 15.2562 46.1464 15.7042 45.6144 16.0309C45.0917 16.3482 44.4711 16.5069 43.7524 16.5069ZM43.7524 15.5269C44.4711 15.5269 45.0451 15.2795 45.4744 14.7849C45.9131 14.2902 46.1324 13.5995 46.1324 12.7129C46.1324 11.8262 45.9177 11.1309 45.4884 10.6269C45.0684 10.1229 44.4897 9.87086 43.7524 9.87086C43.0431 9.87086 42.4644 10.1229 42.0164 10.6269C41.5777 11.1215 41.3584 11.8215 41.3584 12.7269C41.3584 13.5949 41.5731 14.2809 42.0024 14.7849C42.4317 15.2795 43.0151 15.5269 43.7524 15.5269ZM49.7195 16.3809L47.7875 9.03086H48.9355L50.5455 15.2469H50.6015L52.1415 9.03086H53.4155L54.9975 15.2469H55.0395L56.6215 9.03086H57.7275L55.7955 16.3809H54.3115L52.7575 10.4729H52.7015L51.2035 16.3809H49.7195Z",
    fill: "#4CAF50"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_155_81",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.1719 1.07422) rotate(42.715) scale(40.597 47.4035)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CAF50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.780575,
    stopColor: "#1C1B33",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_155_81",
    x1: 4.22703,
    y1: 2.46771e-7,
    x2: 7.74283,
    y2: 20.5194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLowImg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/low-img.59ff4367cc4749a761f75900bae7f81e.svg";